module.exports = __webpack_public_path__ + "img/logo-grayscale-dark.e3ce5714.svg";